exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./apps/guias/~/core-js/modules/_wks-ext.js
// module id = 121
// module chunks = 0